import React, {useState} from 'react';
import rightArrow from "../assets/rightarrow.svg";
import close from "../assets/close.svg";
import arrow from "../assets/arriow.svg";
import {
    Amount,
     Box, BoxTitle,
    ButtonsContainer, BuyButton, CancelButton, Close, CryptoValue,
     DepositModal, DepositTitle,
    Heading, InfoContainer,
    InputContainer, Label, LargeButton,  OptionItem, OptionsContainer, Select, SmallButton, StakeInput,
     Wrapper
} from "./Staking";




const Loans = () => {
    const [isCloseBtnActive, setCloseBtnActive] = useState(false)
    const [isModalOpen, setModalOpen] = useState(false)


    return (
        <Wrapper>

            <Heading>Take a Loan</Heading>
            <InputContainer>
                <CryptoValue>ETH</CryptoValue>
                <StakeInput placeholder="0.000" />
                <ButtonsContainer>
                    <SmallButton>
                        1
                    </SmallButton>
                    <SmallButton>
                       5
                    </SmallButton>
                    <LargeButton>
                        <img src={rightArrow} alt="arrow"/>
                    </LargeButton>
                    <SmallButton>
                        10
                    </SmallButton>
                    <SmallButton>
                        20
                    </SmallButton>

                </ButtonsContainer>
            </InputContainer>

            <InfoContainer secondary>
                <Box  >
                    <BoxTitle>Coming Soon</BoxTitle>
                </Box>
            </InfoContainer>


            <DepositModal isModalOpen={isModalOpen}>
                <DepositTitle>Buy Crypto</DepositTitle>
                <Label>Currency</Label>
                <Select  onClick={() => setCloseBtnActive(!isCloseBtnActive)}>
                    Ambient
                    <OptionsContainer isCloseBtnActive={isCloseBtnActive} >
                        <Close src={close} alt=""  onClick={() => setCloseBtnActive(!isCloseBtnActive)}/>
                        <OptionItem>Ambient <img src={arrow} alt="arrow"/></OptionItem>
                    </OptionsContainer>
                    <img src={arrow} alt="arrow"/>
                </Select>
                <Label>Amount</Label>
                <Amount placeholder="24 000"/>
                <BuyButton> Buy Now</BuyButton>
                <CancelButton onClick={() => setModalOpen(!isModalOpen)}>Cancel</CancelButton>
            </DepositModal>
        </Wrapper>
    );
};

export default Loans;